import { Actions, WrenchScrewdriverIcon, Tooltip, Link } from "@";

// Component for rendering table actions (edit and delete)
export const TableActions = ({ row, handlerEdit, deleteHandler }) => {
  return (
    <Actions notShow row={row} edit={handlerEdit} delete={deleteHandler}>
      <Link
        className="icon-style"
        data-tooltip-placement="right"
        to={`/settings-users/${row.id}/edit`}
        data-tooltip-target={`action-permission-${row.id}`}
      >
        <WrenchScrewdriverIcon className="w-6" />
      </Link>
      <Tooltip title="تعديل الصلاحيات" id={`action-permission-${row.id}`} />
    </Actions>
  );
};

// Define table columns for user data
export const tableColumns = [
  {
    name: "الاسم",
    selector: ({ displayName }) => displayName,
  },
  {
    name: "البريد الالكتروني",
    selector: ({ email }) => email,
  },
  {
    name: "رقم الهاتف",
    selector: ({ phoneNumber }) => phoneNumber,
  },
];
